module.exports = __webpack_public_path__ + "static/976657866.f5528c60.jpg";